import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';
import { useAppSelector, useDeviceSelector, useUserSelector } from '@core/js/store/hooks';
import { useGetCMSResourceURL } from '@core/js/hooks/useGetCMSResourceURL';
import { languageService } from '@theme/js/services/language.service';
import { workerService } from '@core/js/services/worker.service';

import * as actions from '@core/js/components/system/App/store/actions';

/* Lugano changes */
export const addTwoLetterLanguageInUrlOnMenu = (menuItems, twoLetterLanguage) => {
    const languages = languageService.getAllLocalesTwoLetterLanguage(); // ['en', 'de', 'fr', 'it']

    const isAbsoluteUrl = url => /^(http:\/\/|https:\/\/|www\.|ftp:\/\/)/.test(url);
    const hasLangPrefix = url => languages.some(lang => url.startsWith(`/${lang}/`));

    const updateMenuItem = ({ url, friendlyURL, children, ...rest }) => ({
        ...rest,
        url: !hasLangPrefix(url) && !isAbsoluteUrl(url) ? `/${twoLetterLanguage}${url}` : url,
        friendlyURL: !hasLangPrefix(friendlyURL) && !isAbsoluteUrl(friendlyURL)
            ? `/${twoLetterLanguage}${friendlyURL}`
            : friendlyURL,
        children: children?.map(updateMenuItem)
    });

    return menuItems.map(updateMenuItem);
};
/* Lugano changes */

export const useGetMenuItems = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const formFactor = useDeviceSelector(prop('formFactor'));
    const requestStamp = useAppSelector(prop('requestStamp'));

    useEffect(() => {
        if (!lang || !formFactor) {
            return;
        }
        const requestURL = getCMSResourceURL(`/initialResources/menu/${lang}_${formFactor}`, { t: requestStamp });

        workerService.request('json', requestURL)
            .then(({ menuItems }) => {
                const menuItemsWithLanguage = addTwoLetterLanguageInUrlOnMenu(menuItems, lang.slice(0, 2)); /* Lugano changes */

                dispatcher.dispatch('menu:items', menuItemsWithLanguage); /* Lugano changes */
                dispatch(actions.updateMenuItems(menuItemsWithLanguage)); /* Lugano changes */
            });
    }, [dispatch, lang, formFactor, requestStamp, getCMSResourceURL]);
};
